/**
 * 受保护路由组件 - 需要认证才能访问
 */

import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'admin' | 'super_admin' | 'user';
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 检查角色权限
  if (requiredRole && user) {
    // 超级管理员可以访问所有页面
    if (user.role === 'super_admin') {
      return <>{children}</>;
    }
    
    // admin角色要求检查：管理员和超级管理员都可以访问
    if (requiredRole === 'admin' && user.role === 'admin') {
      return <>{children}</>;
    }
    
    // 严格匹配角色
    if (user.role !== requiredRole) {
      return <Navigate to="/tools" replace />;
    }
  }

  return <>{children}</>;
}

